<template>
  <div v-if="isVisible(field,application) && isSectionVisible(section)" :id="field.elemId" class="ApplicationReviewCollection">
    <div
      class="collectionItemFields"
      v-for="(collectionItem,index) in getCollection()"
      v-if="!isItemFilteredOut(collectionItem)"
      :key="field.apiKey + index"
    >
      <ApplicationFieldCollectionHeading
        :field="field"
        :application="application"
        :collectionItem="collectionItem"
        :collectionItemIndex="index"
        :collectionSize="getCollection().length"
      />

      <div
        v-for="collectionItemField in field.fields(collectionItem, index, $store)"
        :key="collectionItemField.apiKey"
      >
        <ApplicationReviewCollection
          v-if="collectionItemField.type == 'COLLECTION'"
          :section="section"
          :field="collectionItemField"
          :alerts="alerts"
        />
        <ApplicationFieldReadOnly
          v-else
          :field="collectionItemField"
          :section="section"
          :alert="alertByApiKey(collectionItemField)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import _get from 'lodash/get'

import ApplicationFieldCollection from './ApplicationFieldCollection.vue'
import ApplicationFieldCollectionHeading from './ApplicationFieldCollectionHeading.vue'
import ApplicationFieldReadOnly from './ApplicationFieldReadOnly.vue'
import ApplicationReviewCollection from './ApplicationReviewCollection.vue'

import ApplicationMixin from '@/components/mixins/application'
import fieldsMixin from '@/components/mixins/fieldsMixin'

export default {
  name: 'ApplicationReviewCollection',
  components: {
    ApplicationFieldCollectionHeading,
    ApplicationReviewCollection,
    ApplicationFieldReadOnly,
    ApplicationFieldCollection
  },
  mixins: [ApplicationMixin, fieldsMixin],
  props: ['section', 'field', 'alerts'],
  computed: {
    isReviewing() {
      return (
        this.application && this.application.meta.sectionExpandedId === 'review'
      )
    }
  },
  methods: {
    alertByApiKey(field) {
      return this.alerts.find(item => item.field.apiKey === field.apiKey)
    },
    isVisible(field, application) {
      if (!application) {
        return false
      }
      if (field.visible) {
        return field.visible(application)
      } else {
        return true
      }
    },
    isSectionVisible(section) {
      if(section.id === 'shelter'){
      const service = this.$store.state.application.services.type
      if (service && service.find(item => item === 'rentMortgage' || item === 'securityDeposit')) {
          return service.find(item => item === 'rentMortgage' || item === 'securityDeposit') .length > 0       
      }
     }else{
      return  true
      }
     },
    getCollection() {
      try {
        return _get(this, `$store.state.application.${this.field.apiKey}`) || []
      } catch (ex) {
        return []
      }
    },
    isItemFilteredOut(collectionItem) {
      if (this.field.filter) {
        return (
          collectionItem[this.field.filter.apiKey] !== this.field.filter.value
        )
      }
    }
  }
}
</script>

<style lang="scss">
.ApplicationReviewCollection {
  .ApplicationFieldCollectionHeading {
    padding: 0 0 2rem;

    h3 {
      margin-bottom: 0;
    }
  }

  h3:first-child {
    margin-top: $content-padding * 1.25;
  }

  .collectionItemFields .collectionItemFields {
    margin: 0;
    padding: 0;
  }
}
</style>

<style lang="scss" scoped>
.ApplicationReviewCollection {
  h2 {
    padding: 0 $content-padding;
    margin: 0 0 3.5rem;
  }

  .collectionItemFields {
    margin-top: $content-padding * 1.25;
    margin-bottom: $content-padding * 1.25;
    padding: $content-padding * 2;
    background: $color-grey-2;

    .collectionItemFields {
      padding: 0;
      margin: 0;
    }

    .collectionFooter {
      button.primary {
        padding: 0;
        color: $color-primary;
        background: transparent !important;
      }
    }
  }

  .columnLayout {
    display: inline-block;
    width: 33.33%; // Currently giving a three column layout - TODO: Make responsive

    & > * {
      width: 100%;
    }
  }

  .collectionFooter {
    margin: 0.5rem 0 4rem 0;

    .ApplicationFieldAlert {
      padding: 0;
      margin: 0.5rem 0;
    }

    &.full {
      padding: 0 1rem;

      .add {
        margin: 0;
        display: block;
        text-align: center;
        width: 100%;
      }
    }
  }
}
</style>
